import React from 'react';
import { useScreenInit } from './useScreenInit';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofToast } from './components/SocialProofToast';
import { Hero } from './components/Hero';
import { Manifesto } from './components/Manifesto';
import { WhyReadThis } from './components/WhyReadThis';
import { FiveReasonsHeader } from './components/FiveReasonsHeader';
import { WhatYouLearn } from './components/WhatYouLearn';
import { Dedication } from './components/Dedication';
import { WarningSection } from './components/WarningSection';
import { BookExcerpts } from './components/BookExcerpts';
import { Testimonials } from './components/Testimonials';
import { FourReasons } from './components/FourReasons';
import { PricingGuarantee } from './components/PricingGuarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e8e2d4] font-sans selection:bg-[#d4a85a]/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <SocialProofToast data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Manifesto data-id="element-5" />
        <WhyReadThis data-id="element-6" />
        <FiveReasonsHeader data-id="element-7" />
        <WhatYouLearn data-id="element-8" />
        <Dedication data-id="element-9" />
        <WarningSection data-id="element-10" />
        <BookExcerpts data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FourReasons data-id="element-13" />
        <PricingGuarantee data-id="element-14" />
        <FAQ data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}